import { TgTaskState } from './state';
import { apiUrl } from '@/env';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { ITgTask, ITgOneTaskStat, ITgTasksStatData } from '@/interfaces/tg-tasks';


export const mutations = {
  setTgTasks(state: TgTaskState, payload: ITgTask[]) {
    // добавляем флаг isExporting; его пока нет в PG
    // если isExporting = true, иконка загрузки файлов заблокирована
    payload.forEach((item) => {
      item.isExporting = state.tg_tasks.find((task) => task.id === item.id)?.isExporting;
      item.isDownloading = state.tg_tasks.find((task) => task.id === item.id)?.isDownloading;
      if (item.status === 'ACTIVE') {
        const taskActive = state.tg_tasks.find((t) => t.id === item.id);
        if (taskActive && taskActive.stats) item.stats = taskActive.stats;
      }
      if (item.isExporting) item.status = 'EXPORT';
      else if (item.isDownloading) item.status = 'DOWNLOAD';
    });
    state.tg_tasks = payload;
  },
  setTgTask(state: TgTaskState, payload: ITgTask) {

    // const newList: ITgTask[] = state.yt_tasks.slice();
    // const index = newList.findIndex(item => item.id === payload.id);
    // if (index !== -1) {
    //     newList[index] = payload;
    //     state.yt_tasks = newList;
    // };

    // самый быстрый вариант
    const newList: ITgTask[] = state.tg_tasks.slice();
    for (let i = 0; i < newList.length; i++)
      if (newList[i].id === payload.id) {
        newList[i] = payload;
        break;
      }
    state.tg_tasks = newList;
  },

  // изменяем флаг isExporting
  setTgTaskIsExporting(state: TgTaskState, payload: { id: number, isExporting: boolean}) {
      const task = state.tg_tasks.find((item: ITgTask) => item.id === payload.id);
      if (task) task.isExporting = payload.isExporting;
  },

  // изменяем флаг isDownloading
  setTgTaskIsDownloading(state: TgTaskState, payload: { id: number, isDownloading: boolean}) {
      const task = state.tg_tasks.find((item: ITgTask) => item.id === payload.id);
      if (task) task.isDownloading = payload.isDownloading;
  },

  setTgTaskStatus(state: TgTaskState, payload: { id: number, status: string}) {
      const task = state.tg_tasks.find((item: ITgTask) => item.id === payload.id);
      if (task) task.status = payload.status;
  },

  setTgTasksStat(state: TgTaskState, payload: ITgTasksStatData) {
    if (payload.tasks)
      state.tg_tasks = state.tg_tasks.map((t: ITgTask) => {
        const taskStat = payload.tasks.find((s: ITgOneTaskStat) =>  t.id === s.task_id);
        if (taskStat) {
          t.status = taskStat.status;
          t.datetime_end = taskStat.datetime_end;

          const prev = t.stats?.prev;
          const prev_time = t.stats?.prev_time;

          t.stats = taskStat.stats;

          // записыаем стартовые значения количества найденных данных и времени
          // для расчета времени до завершения парсинга
          if (t.stats) {
            t.stats.prev = prev;
            t.stats.prev_time = prev_time;

            const curTime = new Date();

            if (t.stats.found_count > 0) {
              if (t.stats.prev === undefined)
                t.stats.prev = t.stats.found_count;

              if (t.stats.prev_time === undefined)
                t.stats.prev_time = curTime;
            }
          }

          if (taskStat.result)
            t.result = `${apiUrl}/api/v1/tg-tasks/result/${taskStat.result}`;
        }
        return t;
      });
  },

};

const { commit } = getStoreAccessors<TgTaskState, State>('');

export const commitSetTgTask = commit(mutations.setTgTask);
export const commitSetTgTasks = commit(mutations.setTgTasks);
export const commitSetTgTasksStat = commit(mutations.setTgTasksStat);
export const commitSetTgTaskIsExporting = commit(mutations.setTgTaskIsExporting);
export const commitSetTgTaskIsDownloading = commit(mutations.setTgTaskIsDownloading);
export const commitSetTgTaskStatus = commit(mutations.setTgTaskStatus);
